import { render, staticRenderFns } from "./geographicalLevelSelector.vue?vue&type=template&id=15163c30&scoped=true&"
import script from "./geographicalLevelSelector.vue?vue&type=script&lang=js&"
export * from "./geographicalLevelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15163c30",
  null
  
)

export default component.exports